import React from 'react'
import { Box, Button, Stack, Typography } from '@mui/material'

import { Modal } from '#/shared/ui/modal/modal'

import styles from './tour-confirm-skip-modal.module.scss'

interface TourConfirmSkipModalProps {
	open: boolean
	onConfirm: () => void
	onClose: () => void
}

export const TourConfirmSkipModal: React.FC<TourConfirmSkipModalProps> = ({
	open,
	onConfirm,
	onClose,
}) => (
	<Modal open={open} onClose={onClose}>
		<Box className={styles.content}>
			<Stack spacing={2}>
			<Typography className={styles.title}>Вы уверены, что хотите пропустить обучение?</Typography>
			<Box className={styles.confirmModalButtons}>
				<Button onClick={onClose} fullWidth className={styles.confirmButton}>
					Нет, остаться
				</Button>
				<Button onClick={onConfirm} fullWidth variant="outlined" className={styles.skipButton}>
					Да, пропустить
				</Button>
			</Box>
			</Stack>
		</Box>
	</Modal>
)
